export const PATIENT_MRN_SYNC_STATUS = {
  SYNCED: "synced",
  UNCHANGED: "unchanged",
  /** The CRM answered; the clinic has not assigned a number yet. */
  NOT_ASSIGNED: "not_assigned",
  /** Nothing on the CRM to look this patient up by.  */
  NOT_LINKED: "not_linked",
  NO_CRM: "no_crm",
} as const;

export type PatientMrnSyncStatus =
  (typeof PATIENT_MRN_SYNC_STATUS)[keyof typeof PATIENT_MRN_SYNC_STATUS];

export type PatientMrnSyncResult = {
  status: PatientMrnSyncStatus;
  mrn: string | null;
  integrationName: string | null;
};
